import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { Box, Button, Hidden } from '@material-ui/core'

import closeIcon from '../../../images/closeIcon.svg';
import logo from '../../../images/logo.png';
import smallLogo from '../../../images/smallLogo.svg';
import moduleMiniIcon from "../../../images/moduleMiniIcon.svg"
import nawalAbboubExpert from "../../../images/nawalAbboubExpert.png";
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import LanguageContext from "../../../contexts/LanguageContext"
import UserContext from "../../../contexts/UserContext"

import { FormatSwitch } from "../../../pages/Formation"
import ScaleThumbForm from "./ScaleThumbForm"

const TopBar = ({ setViewPlanCours, viewPlanCours }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{
      background:"transparent",
      height:["60px", "80px", "80px", "80px"],
      minHeight:["60px", "80px", "80px", "80px"],
      padding:"0px 25px",
      display:"flex",
      alignItems:"center",
      justifyContent:"space-between",
      gap:["10px", "20px"],
    }}>
      <Box
        sx={{
          width:["15px", "20px"],
          minWidth:["15px", "20px"],
        }}
      />
      <Box sx={{
        flex:1,
        display:"flex",
        gap:["10px", "20px"],
        justifyContent:"center",
        userSelect:"none",
        overflow:"hidden",
      }}>
        <Box
          sx={{
            width:["0px", "130px", "130px", "160px"],
            minWidth:["0px", "130px", "130px", "160px"],
          }}
        >
          <img
            src={logo}
            style={{width:"100%"}}
          />
        </Box>
        <Box
          sx={{
            width:["23px", "0px"],
            minWidth:["23px", "0px"],
          }}
        >
          <img
            src={smallLogo}
            style={{width:"100%"}}
          />
        </Box>
      </Box>
      <Box
        onClick={() => {
          setViewPlanCours(false)
        }}
        sx={{
          width:["15px", "20px"],
          minWidth:["15px", "20px"],
        }}
      >
        <img
          src={closeIcon}
          style={{width:"100%", cursor:"pointer"}}
        />
      </Box>
    </Box>
  )
}

export const BottomBar = ({ actFormation}) => {

  const [finalProgressBar, setFinalProgressBar] = useState(0)

  useEffect(() => {
    let finalProgressBar = 0
    if (actFormation?.progress) {
      setFinalProgressBar(actFormation?.progress)
    }
  }, [actFormation])


  return (
    <Box sx={{
      background:"white",
      height:["70px", "80px", "80px", "80px"],
      minHeight:["70px", "80px", "80px", "80px"],
    }}>
      <Box sx={{
        display:"flex",
        height:"calc(100%)",
        justifyContent:"space-between",
        alignItems:"center",
        padding:"0px 25px",
        gap:"20px",
      }}>
        <Box sx={{
          display:"flex",
          gap:"7px",
          alignItems:"center",
          overflow:"hidden",
          maxWidth:"100%",
        }}>
          <Box sx={{width:["15px", "19px"], minWidth:["15px", "19px"]}}>
            <img src={moduleMiniIcon} style={{width:"100%"}} />
          </Box>
          <Box sx={{
            color:"text.black",
            fontSize:["16px", "22px", "22px", "22px"],
            whiteSpace:"noWrap",
            overflow:"hidden",
            textOverflow:"ellipsis",
            userSelect:"none"
          }}>
            {actFormation?.name}
          </Box>
        </Box>
        <Box>
          <Box sx={{
            display:"flex",
            gap:"5px",
            alignItems:"center",
          }}>
            <Box sx={{
              width:["100px", "110px"],
              height:["10px", "12px"],
              border:"1px solid black",
              position:"relative"
            }}>
              <Box sx={{position:"absolute", top:0, left:0, height:"100%", width:finalProgressBar+"%", background:"black"}} />
            </Box>
            <Box sx={{
              color:"text.black",
              fontSize:["14px", "16px", "16px", "16px"],
            }}>
              {finalProgressBar}%
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

const PlanCours = ({ actFormation, actPlan, lastDoneIndex, setViewPlanCours, viewPlanCours }) => {

  const { actLanguage, languageValues } = useContext(LanguageContext)
  const { forceNewIndexes } = useContext(UserContext)

  const [actFormat, setActFormat] = useState(null)

  const [tab, setTab] = useState("followed")
  const [completed, setCompleted] = useState([])
  const [followed, setFollowed] = useState([])

  useEffect(() => {
    if (actFormation && lastDoneIndex) {
      let newActFormat = actFormation?.chapitre[lastDoneIndex?.chapitre].partie[lastDoneIndex?.partie].sequence[lastDoneIndex?.sequence]
      if (newActFormat) {
        setActFormat(newActFormat)

        let newCompleted = []
        let newFollowed = []
        let findAct = false
        let indexChap = 0
        for (var chapitre of actFormation.chapitre) {
          let indexPart = 0
          for (var partie of chapitre.partie) {
            let indexSeq = 0
            for (var sequence of partie.sequence) {
              if (sequence.id === newActFormat.id) {
                findAct = true
              } else {
                let indexes = { chapitre: indexChap, partie: indexPart, sequence: indexSeq }
                if (findAct) {//on a trouvé l'actuel, la suite c'est du followed
                  newFollowed.push({
                    format : JSON.parse(JSON.stringify(sequence)),
                    indexes : indexes
                  })
                } else {//on est avant l'actuel, c'est donc du completed
                  newCompleted.push({
                    format : JSON.parse(JSON.stringify(sequence)),
                    indexes : indexes
                  })
                }
              }
              indexSeq++
            }
            indexPart++
          }
          indexChap++
        }

        //console.log(newCompleted)
        //console.log(newFollowed)

        setCompleted(newCompleted)
        setFollowed(newFollowed)
        if (newFollowed.length === 0 && newCompleted.length > 0) {
          setTab("completed")
        } else {
          setTab("followed")
        }
      }
    } else {
      setActFormat(null)
      setCompleted([])
      setFollowed([])
    }
  }, [actFormation, lastDoneIndex])



  return (
    <Box sx={{
      position:"absolute",
      top:0,
      left:0,
      width:"100%",
      height:"100vh",
      backgroundColor:"background.grey",
      zIndex:99,
      display:"flex",
      flexDirection:"column",
    }}>
      <TopBar setViewPlanCours={setViewPlanCours} viewPlanCours={viewPlanCours}/>
      <Box sx={{
        flex:1,
        display:"flex",
        flexDirection:"row",
        justifyContent:"center",
        overflowX:"hidden",
        overflowY:"auto",
      }}>
        <Box sx={{
          flex:1,
          maxWidth:"1140px",
          overflowX:["hidden", "hidden", "unset", "unset"],
          padding:["0px 25px", "0px 40px", "0px 60px", "0px 170px"],
        }}>
          {/* REPRENDRE ACT FORMAT*/}
          {actFormat &&
            <Box sx={{
              marginBottom:["0px", "45px"]
            }}>
              <Box sx={{
                color:"text.black",
                fontSize:["24px", "30px", "30px", "34px"],
                marginBottom:["20px", "25px", "25px", "30px"]
              }}>
                {languageValues?.dashboard?.stepper?.resumeBtn[actLanguage]}
              </Box>
              <Box sx={{
                display:"flex",
                flexDirection:["column", "row"],
                columnGap:["40px", "40px", "40px", "50px"],
                rowGap:"20px",
              }}>
                <Box sx={{
                  flex:0.45,
                  overflow:"hidden"
                }}>
                  <ScaleThumbForm
                    onClick={
                      actFormation?.isOpen ? () => {
                        forceNewIndexes({chapitre : lastDoneIndex?.chapitre, partie : lastDoneIndex?.partie, sequence : lastDoneIndex?.sequence})
                        setViewPlanCours(false)
                      }
                      : null
                    }
                  >
                    <FormatSwitch
                      actFormation={actFormation}
                      format={actFormation?.chapitre[lastDoneIndex?.chapitre]?.partie[lastDoneIndex?.partie]?.sequence[lastDoneIndex?.sequence]}
                      actIndex={{chapitre : lastDoneIndex?.chapitre, partie : lastDoneIndex?.partie, sequence : lastDoneIndex?.sequence}}
                      actPlan={actPlan}
                      onlyContent
                    />
                  </ScaleThumbForm>
                </Box>
                <Box sx={{
                  flex : 0.65,
                  display:"flex",
                  flexDirection:"column",
                  justifyContent:"center",
                  overflow:"hidden",
                  gap:["10px", "15px"],
                }}>
                  <Box sx={{
                    overflow:"hidden",
                    color:"text.black",
                    fontSize:["22px", "28px", "28px", "32px"],
                    whiteSpace:"noWrap",
                    textOverflow:"ellipsis",
                    textTransform:"capitalize",
                    userSelect:"none",
                  }}>
                    {actFormat?.exerciceTitle}
                  </Box>
                  <Box sx={{
                    display:"flex",
                    gap:"12px",
                  }}>
                    <Box sx={{
                      width:"40px",
                      height:"40px"
                    }}>
                      <img src={nawalAbboubExpert} style={{width:"100%", height:"100%"}} />
                    </Box>
                    <Box sx={{
                      display:"flex",
                      flexDirection:"column",
                      gap:"3px",
                      justifyContent:"center",
                    }}>
                      <Box sx={{
                        fontSize:"15px",
                        color:"text.black",
                        whiteSpace:"noWrap",
                      }}>
                        Nawal Abboub
                      </Box>
                      <Box sx={{
                        fontSize:"13px",
                        color:"text.subTitle",
                        whiteSpace:"noWrap",
                      }}>
                        {languageValues?.dashboard?.expertDesc[actLanguage]}
                      </Box>
                    </Box>
                  </Box>
                  <Hidden smDown>
                    <Box>
                      <Button
                        onClick={
                          actFormation?.isOpen ? () => {
                            forceNewIndexes({chapitre : lastDoneIndex?.chapitre, partie : lastDoneIndex?.partie, sequence : lastDoneIndex?.sequence})
                            setViewPlanCours(false)
                          }
                          : null
                        }
                        size="large"
                        type="submit"
                        variant="contained"
                        sx={{
                          fontSize:"16px",
                          whiteSpace:"nowrap",
                          paddingLeft:"40px",
                          paddingRight:"40px",
                          marginTop:"5px",
                        }}
                      >
                        {languageValues?.dashboard?.stepper?.resumeBtn[actLanguage]}
                      </Button>
                    </Box>
                  </Hidden>
                </Box>
              </Box>
              <Hidden smUp>
                <Box sx={{
                  background:"#E4E4E4",
                  height:"1px",
                  marginTop:"35px",
                  marginBottom:"35px"
                }}>
                </Box>
              </Hidden>
            </Box>
          }
          {/* END REPRENDRE ACT FORMAT*/}

          {/* FOLLOWED & COMPLETED */}
          {(completed?.lenght > 0 || followed?.length > 0) &&
            <Box>
              <Box sx={{
                display:"flex",
                gap:["15px", "25px", "25px", "35px"],
                color:"text.black",
                fontSize:["16px", "22px", "22px", "26px"],
                marginBottom:["30px", "37px", "37px", "45px"],
                userSelect:"none",
                textUnderlineOffset: "15px",
              }}>
                {followed?.length > 0 &&
                  <Box
                    onClick={() => { setTab("followed") }}
                    sx={{
                      textDecoration:tab==="followed" && "underline",
                      cursor:"pointer",
                    }}
                  >
                    {languageValues?.formation?.planCours?.comingUp[actLanguage]}
                  </Box>
                }
                {completed?.length > 0 &&
                  <Box
                    onClick={() => { setTab("completed") }}
                    sx={{
                      textDecoration:tab==="completed" && "underline",
                      cursor:"pointer",
                    }}
                  >
                    {languageValues?.formation?.planCours?.completed[actLanguage]}
                  </Box>
                }
              </Box>

              <Box sx={{
                display:"flex",
                flexDirection:"column",
                gap:["10px", "15px", "20px", "25px"],
                paddingBottom:"20px"
              }}>
                {tab === "followed" && [...followed]?.map((item, index) => {
                  return (
                    <ItemFormat key={index} item={item} type="followed" actPlan={actPlan} actFormation={actFormation} setViewPlanCours={setViewPlanCours}/>
                  )
                })}
                {tab === "completed" && [...completed]?.reverse()?.map((item, index) => {
                  return (
                    <ItemFormat key={index} item={item} type="completed" actPlan={actPlan} actFormation={actFormation} setViewPlanCours={setViewPlanCours}/>
                  )
                })}
              </Box>
            </Box>
          }
          {/* END FOLLOWED & COMPLETED */}
        </Box>
      </Box>
      <BottomBar actFormation={actFormation} />
    </Box>
  )
}

const ItemFormat = ({ actFormation, item, type, setViewPlanCours, actPlan }) => {

  const { actLanguage, languageValues } = useContext(LanguageContext)
  const { forceNewIndexes } = useContext(UserContext)


  const goToThis = () => {
    forceNewIndexes(item?.indexes)
    setViewPlanCours(false)
  }


  let test = languageValues?.formats?.[item?.format?.type]
  let formatTitle = "Other"
  if (test) {
    formatTitle = test[actLanguage]
  }


  return (
    <Box
      onClick={type==="completed" ? goToThis : null}
      sx={{
        display:"flex",
        gap:["15px", "20px", "25px", "30px"],
        overflow:"hidden",
        cursor:type==="completed" ? "pointer" : "default",
      }}
    >
      <Box sx={{
        height:["50px", "80px", "120px", "135px"],
        minHeight:["50px", "80px", "120px", "135px"],
        aspectRatio:1.5,
        overflow:"hidden"
      }}>
        <ScaleThumbForm
          completedIcon={type==="completed"?true:false}
          onClick={type==="completed" ? () => {} : null}
        >
          <FormatSwitch
            actFormation={actFormation}
            format={actFormation?.chapitre[item?.indexes?.chapitre]?.partie[item?.indexes?.partie]?.sequence[item?.indexes?.sequence]}
            actIndex={{chapitre : item?.indexes?.chapitre, partie : item?.indexes?.partie, sequence : item?.indexes?.sequence}}
            actPlan={actPlan}
            onlyContent
          />
        </ScaleThumbForm>
      </Box>
      <Box sx={{
        flex:1,
        overflow:"hidden",
        display:"flex",
        justifyContent:"space-between",
        alignItems:"center",
        gap:["10px", "15px", "15px", "20px"],
        overflow:"hidden",
        userSelect:"none",
      }}>
        <Box sx={{
          display:"flex",
          flexDirection:"column",
          gap:["3px", "5px", "5px", "10px"],
          overflow:"hidden",
        }}>
          <Box sx={{
            color:"text.subTitle",
            fontSize:["12px", "14px", "14px", "15px"],
            whiteSpace:"nowrap",
            textOverflow:"ellipsis",
            overflow:"hidden",
          }}>
            {formatTitle}
          </Box>
          <Box sx={{
            color:"text.color",
            fontSize:["15px", "22px", "22px", "26px"],
            whiteSpace:"nowrap",
            textOverflow:"ellipsis",
            overflow:"hidden",
          }}>
            {item?.format?.exerciceTitle }
          </Box>
          <Hidden mdDown>
            <Box sx={{
              display:"flex",
              gap:"12px",
            }}>
              <Box sx={{
                width:"40px",
                height:"40px"
              }}>
                <img src={nawalAbboubExpert} style={{width:"100%", height:"100%"}} />
              </Box>
              <Box sx={{
                display:"flex",
                flexDirection:"column",
                gap:"3px",
                justifyContent:"center",
              }}>
                <Box sx={{
                  fontSize:"15px",
                  color:"text.black",
                  whiteSpace:"noWrap",
                }}>
                  Nawal Abboub
                </Box>
                <Box sx={{
                  fontSize:"13px",
                  color:"text.subTitle",
                  whiteSpace:"noWrap",
                }}>
                  {languageValues?.dashboard?.expertDesc[actLanguage]}
                </Box>
              </Box>
            </Box>
          </Hidden>
        </Box>
        {type === "completed" &&
          <Hidden smDown>
            <Box>
              <KeyboardArrowDownIcon sx={{transform: "rotate(-90deg)"}}/>
            </Box>
          </Hidden>
        }
      </Box>
    </Box>
  )
}

export default PlanCours
